import { render, staticRenderFns } from "./CommentAlert.vue?vue&type=template&id=4f14273a&scoped=true&"
import script from "./CommentAlert.vue?vue&type=script&lang=js&"
export * from "./CommentAlert.vue?vue&type=script&lang=js&"
import style0 from "./CommentAlert.vue?vue&type=style&index=0&id=4f14273a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f14273a",
  null
  
)

export default component.exports